import {isEmpty} from 'lodash';

export abstract class DataSourceFilter {
    public abstract identifier(): string;

    public abstract onFilterApplied(data: any, parameters: any): boolean;

    public filter(data: any, parameters: any): boolean {
        if (isEmpty(data) || isEmpty(parameters)) {
            return data;
        }
        return this.onFilterApplied(data, parameters);
    }
}
